var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip1000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4104)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7188 43H32.3047V36.3906C32.3047 36.2083 32.3073 35.9844 32.3125 35.7188C32.3177 35.4479 32.3255 35.1719 32.3359 34.8906C32.3464 34.6042 32.3568 34.3464 32.3672 34.1172C32.3099 34.1849 32.1927 34.3021 32.0156 34.4688C31.8438 34.6302 31.6823 34.776 31.5312 34.9062L30.2188 35.9609L29.0547 34.5078L32.7344 31.5781H34.7188V43ZM47.8906 43H45.1406L42.1484 38.1875L41.125 38.9219V43H38.7031V31.5781H41.125V36.8047C41.2865 36.5807 41.4453 36.3568 41.6016 36.1328C41.7578 35.9089 41.9167 35.6849 42.0781 35.4609L45.1719 31.5781H47.8594L43.875 36.6328L47.8906 43Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4104",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#21B152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip1000);
export default __webpack_public_path__ + "static/media/chip1000.3219de0dbe2fb445cb37bbb22f3534cf.svg";
export { ForwardRef as ReactComponent };